import React, { useMemo, useCallback } from "react"

import { camelize } from "inflected"

const ToggleableField = (({ field, children, onChange, ...props }) => {
  const toggle = useCallback(() => {
    if(field.value) return onChange(field.slug, false)
    onChange(field.slug, true)
  })

  return <div field={ field } onClick={ toggle } { ...props } >{ children }</div>
})

const TodoField = (({ field, onChange }) => {
  const color = (field.value) ? 'text-green-400' : ''

  return (
    <div className="darkest-gray-transparent-box">
      <ToggleableField className={ `frow items-center p-1 ${color}` } onChange={ onChange } field={ field }>
        <i className={ clsx('ph', { 'ph-check': field.value, 'ph-circle': !field.value }) } />
        <div className="flex-1 text-sm px-h">{ field.prompt }</div>
      </ToggleableField>
    </div>
  )
})

const LabeledField = (({ field, children, className="" }) => {
  return (
    <div className={ `darkest-gray-transparent-box frow items-center ${className}` }>
      <div className="flex-1 text-sm px-h">{ field.prompt }</div>
      { children }
    </div>
  )
})

const AbstractField = ({ field, onChange }) => {
  const numberInputChanged = useCallback((e) => {
    onChange(field.slug, parseFloat(e.target.value))
  })

  if(field.type == 'int')
    return <LabeledField field={ field }>
             <input type="number" value={ field.value || '0' } onChange={ numberInputChanged } className="input-sm w-50" step={ field.step || 1 } />
             { field.unit }
           </LabeledField>

  if(field.type == 'yes_or_no')
    return <ToggleableField field={ field } onChange={ onChange }>
             <LabeledField field={ field } onChange={ onChange } className="input-inline">
               {
                 field.value ?
                   <div className="text-green-500 text-lg px-d"> Sim </div> : <div className="text-red-500 text-lg px-d"> Não </div>
               }
             </LabeledField>
           </ToggleableField>

  if(field.type == 'todo')
    return <TodoField field={ field } onChange={ onChange } />

  return <div> { `Unknown: ${field.type}` } </div>
}

export default ({ dodone, updateDodone }) => {
  if(Object.keys(dodone.settings?.fields?.configuration || {}).length == 0)
    return null

  const fields = useMemo(() => {
    const sortedFields = Object.values(dodone.settings?.fields?.configuration).sort((a, b) => {
      return a.order - b.order
    })

    sortedFields.forEach((field) => {
      const fieldLog = dodone.log.fields[camelize(field.slug, false)]
      field.value = fieldLog?.value
    })

    return sortedFields
  })

  const fieldChanged = useCallback((slug, value) => {
    dodone.log.fields[camelize(slug, false)].value = value
    updateDodone.mutate({ attributes: { log: dodone.log }})
  })

  return <div>
           {
             fields.map((field) => {
               return <AbstractField key={ field.slug } field={ field } onChange={ fieldChanged } />
             })
           }
         </div>
}
